import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxSpinnerService } from "ngx-spinner";
import { CloudProvider } from "src/app/core/models/cloudProvider";
import { DeploymentService } from "src/app/core/services/deployment.service";
import { NodeConfigService } from "src/app/core/services/node-config.service";
import { NodeService } from "src/app/core/services/node.service";
import { HpcConfig } from "../../../../../core/models/node-config";
import { ConfigEntityService } from "../../../../../core/services/config-entity.service";
import { NavigationService } from "../../../../../core/services/navigation.service";
import { AddNodeConfiguratorComponent } from "../add-node-configurator/add-node-configurator.component";
import { DeleteNodeConfiguratorComponent } from "../modals/delete-node-configurator/delete-node-configurator.component";
import { UpdateNodeConfiguratorComponent } from "../modals/update-node-configurator/update-node-configurator.component";
import { FormControl } from "@angular/forms";
import { distinctUntilChanged, debounceTime } from "rxjs";
import { ImportNodeConfiguratorComponent } from "../modals/import-node-configurator/import-node-configurator.component";
import { ImportCSVType } from "../../../../../core/models/globals";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { UserRoleNames } from "src/app/core/models/users";

@Component({
  selector: 'app-list-node-configurator',
  templateUrl: './list-node-configurator.component.html',
  styleUrls: ['./list-node-configurator.component.scss'],
})
export class ListNodeConfiguratorComponent implements OnInit {
  available: boolean;
  cloudProviders: CloudProvider[];
  configs: HpcConfig[];
  p: number = 1;
  cloudJson = [
    {
      value: 0,
      name: 'Microsoft Azure',
    },
    {
      value: 1,
      name: 'Amazon Web Services',
    },
    {
      value: 2,
      name: 'Oracle Cloud Infrastructure',
    },
    {
      value: 3,
      name: 'Google Cloud Platform',
    },
    {
      value: 4,
      name: 'OpenStack',
    },
    {
      value: 5,
      name: 'On-Premise',
    },
    {
      value: 6,
      name: 'KVM Virtualization',
    },
  ];
  filterText = new FormControl('');
  filteredConfigs: HpcConfig[] = [];
  itemsPerPage: number = 15;
  config = {
    itemsPerPage: 18,
    currentPage: 1,
  }
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;

  constructor(
    private dialog: MatDialog,
    public depService: DeploymentService,
    public nodeService: NodeService,
    public nodeConfigService: NodeConfigService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private navService: NavigationService,
    private configEntityService: ConfigEntityService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    //this.navService.sendLeftPanelIndex(10);
    this.configEntityService.sendActiveEntity('Node Configuration');
    this.navService.sendChildData('Node Configuration');
    this.navService.sendParentData('');
    this.loadNodeConfig();
    this.filterText.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value) => {
        this.filteredConfigs = this.configs.filter((config) =>
          config.instanceCode.toLowerCase().includes(value.toLowerCase()) ||
          config.cloudProvider.toLowerCase().includes(value.toLowerCase()) ||
          config.hpcConfigId.toString().toLowerCase().includes(value.toLowerCase())
        );
      });
  }

  loadNodeConfig() {
    this.nodeConfigService.getHpcConfigDetails().subscribe({
      next: (data) => {
        this.configs = JSON.parse(JSON.stringify(data));
        this.filteredConfigs = this.configs;
      },
      error: (err) => {},
      complete: () => {},
    });
  }

  addNewNode() {
    {
      const dialogRef = this.dialog.open(AddNodeConfiguratorComponent, {
        width: '40%',
        height: '80%',
        autoFocus: true,
        disableClose: false,
      });
      dialogRef.afterClosed().subscribe(() => this.loadNodeConfig());
    }
  }

  addBulkNode() {
    const dialogRef = this.dialog.open(ImportNodeConfiguratorComponent, {
      autoFocus: false,
      disableClose: true,
      width: "600px",
      data: {
        importType: ImportCSVType.Nodes,
        requiredParams:
        "instanceCode,cpuCores,hpcUnits,cpuType,cloudProvider,ramSize,hddType,hddSize,isRdmaSupported,numOfSockets,coresPerSocket,threadsPerCore,noOfGPU,gpuMemorySize,gpuModel"        
      },
    });
  }

  updateNodeConfiguration(
    cpuCores,
    cpuType,
    hddSize,
    ramSize,
    hddType,
    cloudProvider,
    numOfSockets,
    coresPerSocket,
    threadsPerCore,
    noOfGPU,
    gpuMemorySize,
    gpuModel,
    isRdmaSupported,
    hpcConfigId,
    instanceCode,
    hpcUnits
  ) {
    let cloudProv = this.cloudJson.find((x) => x.name === cloudProvider).value;
    let nodeConfig: HpcConfig = {
      instanceCode: instanceCode,
      hpcConfigId: hpcConfigId,
      cpuCores: cpuCores,
      hpcUnits: hpcUnits,
      cpuType: cpuType,
      cloudProvider: cloudProv.toString(),
      ramSize: ramSize,
      hddType: hddType,
      hddSize: hddSize,
      isRdmaSupported: isRdmaSupported,
      numOfSockets: numOfSockets,
      coresPerSocket: coresPerSocket,
      threadsPerCore: threadsPerCore,
      maxHpcNodes: 0,
      pricePerHour: 0,
      description: null,
      noOfGPU: noOfGPU,
      gpuMemorySize: gpuMemorySize,
      gpuModel: gpuModel,
      cpuModel: null,
    };
    const dialogRef = this.dialog.open(UpdateNodeConfiguratorComponent, {
      width: '40%',
      height: '80%',
      autoFocus: true,
      disableClose: false,
      data: { nodeConfig },
    });
    dialogRef.afterClosed().subscribe(() => this.loadNodeConfig());
  }

  deleteNodeConfiguration(hpcConfigId) {
    const dialogRef = this.dialog.open(DeleteNodeConfiguratorComponent, {
      autoFocus: false,
      disableClose: true,
      width: '400px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.spinner.show();
        this.nodeConfigService.deleteNodeConfig(hpcConfigId).subscribe({
          next: (data: any) => {
            this.snackBar.open(data.message, 'Ok', { duration: 5000 });
            this.loadNodeConfig();
            this.spinner.hide();
          },
          error: (err: any) => {
            this.snackBar.open(
              err.error.message || 'Action cannot be completed.',
              'Ok',
              { duration: 5000 }
            );
            this.spinner.hide();
          },
        });
      }
    });
  }
}
